const ContactPage = () => {
  return (
    <div className="max-w-4xl mx-auto py-12 px-4">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Contact Us</h1>
      <div className="grid md:grid-cols-2 gap-8">
        <div>
          <h2 className="text-xl font-semibold mb-4">Office Information</h2>
          <p>Phone: +91 9810375098</p>
          <p>Email: office@nfcrwa.com</p>
          <p>Address: OPP A -297 ASSOCIATION ASHOKA PARK ROAD NEW FRIENDS COLONY NEW DELHI 110065</p>
        </div>
        <div>
          <h2 className="text-xl font-semibold mb-4">Office Hours</h2>
          <p>Monday - Friday: 9:00 AM - 6:00 PM</p>
          <p>Saturday: 9:00 AM - 1:00 PM</p>
          <p>Sunday: Closed</p>
        </div>
      </div>
    </div>
  )
}

export default ContactPage
